import React from 'react';
import { FaMoneyBillWave } from 'react-icons/fa';

function PaymentBox() {
  return (
    <div className="payment-box">
      <div className="payment-icon"><FaMoneyBillWave /></div>
      <div className="payment-details">
        <p className="payment-title">Payment details</p>
        <div className="payment-row">
          <span className="payment-label">BaridiMob</span>
          <span className="payment-value">00799999002453634897</span>
        </div>
        <div className="payment-row">
          <span className="payment-label">CCP</span>
          <span className="payment-value">0024536348 / clé 97</span>
        </div>
        <div className="payment-name">Loubna Bouzenzen</div>
      </div>
    </div>
  );
}

export default PaymentBox;